// extracted by mini-css-extract-plugin
module.exports = {"table":"table_table__dgTVa","table__product-info":"table_table__product-info__3O0r0"};